module.exports = __webpack_public_path__ + "res/roboto-v15-latin-500.woff";


//////////////////
// WEBPACK FOOTER
// ./client/app/vendor/googlefonts/roboto-v15-latin-500.woff
// module id = 99
// module chunks = 1